export enum ProductName {
  ACCIDENT = 'ACCIDENT_INSURANCE',
  ACCIDENT_AGREEMENT = 'ACCIDENTAGREEMENT_INSURANCE',
  AKA_CHILD = 'AKA_CHILD_INSURANCE',
  AKA_CRITICAL_ILLNESS = 'AKA_CRITICAL_ILLNESS',
  AKA_FAMILY_ACCIDENT = 'AKA_FAMILY_ACCIDENT_INSURANCE',
  AKA_GROUP_LIFE = 'AKA_GROUP_LIFE_INSURANCE',
  AKA_GROUP_LIFE_CLOSED = 'AKA_GROUP_LIFE_CLOSED_INSURANCE',
  AKA_HEALTH = 'AKA_HEALTH_INSURANCE',
  AKA_HOUSE_CONTENTS = 'AKA_HOUSE_CONTENTS_INSURANCE',
  AKA_OFFICE = 'AKA_OFFICE_INSURANCE',
  AKA_PROFESSIONAL_LIABILITY = 'AKA_PROFESSIONAL_LIABILITY_INSURANCE',
  AKA_STUDENT = 'AKA_STUDENT_INSURANCE',
  AKA_TRAVEL = 'AKA_TRAVEL_INSURANCE',
  AKA_WORK_ACCIDENT = 'AKA_WORK_ACCIDENT_INSURANCE',
  ANIMAL = 'ANIMAL_INSURANCE',
  AURORA_CHILD = 'AURORA_CHILD_INSURANCE',
  AURORA_CHILD_COMPLETE = 'AURORA_CHILD_COMPLETE_INSURANCE',
  AURORA_CRITICAL_ILLNESS = 'AURORA_CRITICAL_ILLNESS_INSURANCE',
  AURORA_DEATH = 'AURORA_DEATH_INSURANCE',
  AURORA_DISABILITY_AND_ACCIDENT = 'AURORA_DISABILITY_AND_ACCIDENT_INSURANCE',
  AURORA_DISABILITY_INTEREST = 'AURORA_DISABILITY_INTEREST_INSURANCE',
  AURORA_DISABILITY_TOTAL = 'AURORA_DISABILITY_TOTAL_INSURANCE',
  BOAT = 'BOAT_INSURANCE',
  BOARD_RESPONSIBILITY = 'BOARD_RESPONSIBILITY_INSURANCE',
  CABIN = 'CABIN_INSURANCE',
  CABIN_CONTENTS = 'CABINCONTENTS_INSURANCE',
  CANCER = 'CANCER_INSURANCE',
  CAR = 'AUTO_INSURANCE',
  CARAVAN = 'CARAVAN_INSURANCE',
  CHILD = 'CHILD_INSURANCE',
  COLLECTIVE_ACCIDENT = 'COLLECTIVE_ACCIDENT_INSURANCE',
  COLLECTIVE_TRAVEL = 'COLLECTIVE_TRAVEL_INSURANCE',
  COMPANY = 'COMPANY_INSURANCE',
  CORPORATE_BUILDING = 'CORPORATE_BUILDING_INSURANCE',
  CORPORATE_CAR = 'CORPORATE_AUTO_INSURANCE',
  CORPORATE_TRACTOR = 'CORPORATE_TRACTOR_INSURANCE',
  CRITICAL_ILLNESS = 'CRITICAL_ILLNESS_INSURANCE',
  DEATH = 'DEATH_INSURANCE',
  DEBT_INSURANCE = 'DEBT_INSURANCE',
  DISABILITY = 'DISABILITY_INSURANCE',
  DISABILITY_FLEX = 'DISABILITY_INSURANCE_FLEX',
  DISABILITY_CAPITAL = 'DISABILITY_CAPITAL_INSURANCE',
  ELECTRIC_SCOOTER = 'ELECTRIC_SCOOTER_INSURANCE',
  EXTENDED_HOUSECONTENTS = 'EXTENDED_HOUSECONTENTS_INSURANCE',
  FLEET = 'FLEET_INSURANCE',
  FLEET_V2 = 'FLEET_INSURANCE_V2',
  HOUSE = 'HOUSE_INSURANCE',
  HOUSE_CONTENTS = 'HOUSECONTENTS_INSURANCE',
  HOUSE_CONTENTS_AGREEMENT = 'HOUSECONTENTSAGREEMENT_INSURANCE',
  HOUSE_CONTENTS_STB_AGREEMENT = 'HOUSECONTENTS_STB_AGREEMENT_INSURANCE',
  HOUSING_ASSOCIATION = 'HOUSING_ASSOCIATION_INSURANCE',
  HOME_SELLER = 'HOME_SELLER_INSURANCE',
  HOME_BUYER_INTEREST = 'HOME_BUYER_INTEREST_INSURANCE',
  HOME_BUYER_MOVE = 'HOME_BUYER_MOVE_INSURANCE',
  HOME_BUYER_HOUSE = 'HOME_BUYER_HOUSE_INSURANCE',
  HOME_BUYER_HOUSE_CONTENTS = 'HOME_BUYER_HOUSE_CONTENTS_INSURANCE',
  HUSEIERNE_HOUSE_CONTENTS = 'HUSEIERNE_HOUSE_CONTENTS_INSURANCE',
  INDUSTRY_INJURY = 'INDUSTRY_INJURY_INSURANCE',
  INSR_DISABILITY = 'INSR_DISABILITY_INSURANCE',
  LIABILITY = 'LIABILITY_INSURANCE',
  LORRY = 'LORRY_INSURANCE',
  MOPED = 'MOPED_INSURANCE',
  MOTORCYCLE = 'MOTORCYCLE_INSURANCE',
  NEW_CHILD = 'NEWCHILD_INSURANCE',
  OFFICE = 'OFFICE_INSURANCE',
  PREGNANT_AND_NEWBORN = 'PREGNANT_AND_NEWBORN_INSURANCE',
  PROJECT = 'PROJECT_INSURANCE',
  PROPERTY_DAMAGE = 'PROPERTY_DAMAGE_INSURANCE',
  RENTAL = 'RENTAL_INSURANCE',
  SOP_SICKNESS_LEAVE = 'SOP_SICKNESS_LEAVE_INSURANCE',
  STORE = 'STORE_INSURANCE',
  TAXI = 'TAXI_INSURANCE',
  TRACTOR = 'TRACTOR_INSURANCE',
  TRAILER = 'TRAILER_INSURANCE',
  TRANSPORT = 'TRANSPORT_INSURANCE',
  TRAVEL = 'TRAVEL_INSURANCE',
  VETERAN_CAR = 'VETERAN_AUTO_INSURANCE',
  VALUABLE = 'VALUABLE_INSURANCE',
}

export enum ErgoProductName {
  AKA_PLUSS = 'A+ Helseforsikring',
  CHILD = 'Behandlingsavtale Topp (Barnas Super)',
  TOP = 'Behandlingsavtale Topp',
  PLUSS = 'Behandlingsavtale Pluss',
  BASIC = 'Behandlingsavtale Basis',
  DEFAULT = 'Behandlingsavtale',
  RETURN = 'Raskt tilbake',
}

export const ErgoProducts = [
  ErgoProductName.AKA_PLUSS,
  ErgoProductName.CHILD,
  ErgoProductName.TOP,
  ErgoProductName.PLUSS,
  ErgoProductName.BASIC,
  ErgoProductName.DEFAULT,
  ErgoProductName.RETURN,
];

export const NoVisibleDiscountProducts = [
  ProductName.DEATH,
  ProductName.CHILD,
  ProductName.CRITICAL_ILLNESS,
  ProductName.CANCER,
  ProductName.DISABILITY,
  ProductName.DISABILITY_FLEX,
  ProductName.DISABILITY_CAPITAL,
  ProductName.NEW_CHILD,
  ProductName.PREGNANT_AND_NEWBORN,
];

export const BasicProducts = [
  ProductName.CAR,
  ProductName.HOUSE,
  ProductName.HOUSE_CONTENTS_STB_AGREEMENT,
  ProductName.HOUSE_CONTENTS,
  ProductName.HOUSE_CONTENTS_AGREEMENT,
  ProductName.CABIN,
  ProductName.ACCIDENT_AGREEMENT,
  ProductName.COLLECTIVE_TRAVEL,
  ProductName.COLLECTIVE_ACCIDENT,
  ProductName.COMPANY,
  ProductName.CORPORATE_BUILDING,
  ProductName.CORPORATE_CAR,
  ProductName.AKA_HOUSE_CONTENTS,
  ProductName.HUSEIERNE_HOUSE_CONTENTS,
  ProductName.LORRY,
];

export const TravelProducts = [
  ProductName.TRAVEL,
  ProductName.AKA_TRAVEL,
  ProductName.COLLECTIVE_TRAVEL,
];

export const ProductsWithTFA = [
  ProductName.CAR,
  ProductName.CORPORATE_CAR,
  ProductName.CORPORATE_TRACTOR,
  ProductName.MOPED,
  ProductName.MOTORCYCLE,
  ProductName.TRACTOR,
  ProductName.VETERAN_CAR,
];

export const DeregisterableVehicleProducts = [
  ProductName.CAR,
  ProductName.MOTORCYCLE,
  ProductName.VETERAN_CAR,
];

export const ReregisterableVehicleProducts = [
  ProductName.CAR,
  ProductName.MOTORCYCLE,
];

export const ProductsWithChangeForm = [
  ProductName.CAR,
  ProductName.HOUSE,
  ProductName.HOUSE_CONTENTS,
  ProductName.CABIN,
  ProductName.CABIN_CONTENTS,
  ProductName.MOTORCYCLE,
  ProductName.TRAVEL,
];

export const ProductsWithCancelForm = [ProductName.ELECTRIC_SCOOTER];

export const ChildProducts = [ProductName.CHILD, ProductName.NEW_CHILD];

/* There could be more, but for now these are the only on with details here */
export const ProductsWithBonus = [ProductName.CAR, ProductName.MOTORCYCLE];

export const ProductsWithLimitedDetails = [
  ProductName.AKA_HEALTH,
  ProductName.AKA_OFFICE,
];
export const ProductsWithFixedPrice = [ProductName.PREGNANT_AND_NEWBORN];

export const PersonalAkaProducts = [
  ProductName.AKA_CHILD,
  ProductName.AKA_CRITICAL_ILLNESS,
  ProductName.AKA_GROUP_LIFE,
];

export const AkaProducts = [
  ProductName.AKA_CHILD,
  ProductName.AKA_CRITICAL_ILLNESS,
  ProductName.AKA_FAMILY_ACCIDENT,
  ProductName.AKA_GROUP_LIFE,
  ProductName.AKA_GROUP_LIFE_CLOSED,
  ProductName.AKA_HEALTH,
  ProductName.AKA_HOUSE_CONTENTS,
  ProductName.AKA_OFFICE,
  ProductName.AKA_PROFESSIONAL_LIABILITY,
  ProductName.AKA_STUDENT,
  ProductName.AKA_TRAVEL,
  ProductName.AKA_WORK_ACCIDENT,
];
